import axios from 'axios';
import { SimCReport } from '../types/simc';
import { API_BASE } from './api';

class SimCService {
    private static instance: SimCService;

    public static getInstance(): SimCService {
        if (!SimCService.instance) {
            SimCService.instance = new SimCService();
        }
        return SimCService.instance;
    }

    // Parse character info from SimC data (basic extraction)
    parseCharacterInfo(simcData: string): { characterName: string; spec: string; className: string } | null {
        try {
            // Look for character name pattern
            const nameMatch = simcData.match(/^(\w+)=/m);
            const characterName = nameMatch ? nameMatch[1] : 'Unknown';

            // Look for spec pattern (this is very basic, you might need to adjust)
            const specMatch = simcData.match(/spec=(\w+)/);
            const spec = specMatch ? specMatch[1] : 'Unknown';

            // Look for class pattern
            const classMatch = simcData.match(/class=(\w+)/);
            const className = classMatch ? classMatch[1] : 'Unknown';

            return { characterName, spec, className };
        } catch (error) {
            console.error('Error parsing SimC data:', error);
            return null;
        }
    }

    // Upload SimC report
    async uploadReport(reportData: string): Promise<SimCReport> {
        const response = await axios
            .post(`${API_BASE}/reports`,
                reportData,
                { headers: { "Content-Type": "text/plain" } }
                );
        return response.data;
    }

    async setReportNote(reportId: string, note: string): Promise<{}> {
        const response = await axios.put(`${API_BASE}/reports/${reportId}`, note,
            { headers: { "Content-Type": "text/plain" } });
        return response.data;
    }

    // Get all reports grouped by user
    async getReports(): Promise<SimCReport[]> {
        const response = await axios.get(`${API_BASE}/reports`);
        return response.data.map((report: SimCReport) => ({
           ...report,
            id: `${report.discord_id}:${report.character}:${report.ts_ms}`,
           uploadedAt: new Date(report.ts_ms)
        }));
    }

    // Get specific report
    async getReport(id: string): Promise<SimCReport> {
        const response = await axios.get(`${API_BASE}/reports/${id}`);
        return response.data;
    }

    // Delete report
    async deleteReport(id: string): Promise<void> {
        await axios.delete(`${API_BASE}/reports/${id}`);
    }
}

export default SimCService.getInstance();
